export default "__VITE_ASSET__a13207e2__"